import type { SxProps, Theme } from "@mui/material";
import { Box, Typography } from "@mui/material";
import type { Maybe } from "../../types";
import InlineLoaderSvg from "./InlineLoaderSvg";

interface Props {
  overlay?: boolean;
  sx?: SxProps<Theme>;
  text?: Maybe<string>;
}

const InlineLoader = ({ overlay, sx, text }: Props) => (
  <Box
    sx={{
      position: overlay ? "absolute" : "relative",
      width: overlay ? "100%" : "inherit",
      height: overlay ? "100%" : "inherit",
      display: "flex",
      flexGrow: 1,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
      pointerEvents: "none",
      ...sx,
    }}
  >
    <Box sx={{ width: "4rem" }}>
      <InlineLoaderSvg />
    </Box>
    {text && <Typography variant="subtitle1">{text}</Typography>}
  </Box>
);

export default InlineLoader;
